
import { GHSegment } from '../math/index';

export default Object.freeze({

  // intersection between closed points
  intersects: function (points0, points1) {
    for (let i = 0, n = points0.length - 1; i < n; i++) {
      const p0 = points0[i];
      const p1 = points0[i + 1];

      for (let j = 0, m = points1.length - 1; j < m; j++) {
        const p2 = points1[j];
        const p3 = points1[j + 1];

        const denom = ((p3.y - p2.y) * (p1.x - p0.x)) - ((p3.x - p2.x) * (p1.y - p0.y));
        const numeA = ((p3.x - p2.x) * (p0.y - p2.y)) - ((p3.y - p2.y) * (p0.x - p2.x));
        const numeB = ((p1.x - p0.x) * (p0.y - p2.y)) - ((p1.y - p0.y) * (p0.x - p2.x));

        if (denom === 0) continue;
        if (Math.abs(numeA) <= Number.EPSILON || Math.abs(numeB) <= Number.EPSILON) continue;

        const uA = numeA / denom;
        const uB = numeB / denom;
        if (uA >= 0 && uA <= 1 && uB >= 0 && uB <= 1) {
          return true;
        }
      }
    }

    return false;
  },

  contains: function (points, point) {
    let result = false;
    let n = points.length;
    for (let i = 0, j = n - 1; i < n; j = i++) {
      if (
        ((points[i].y  > point.y) !== (points[j].y  > point.y)) &&
        (point.x < (points[j].x - points[i].x ) * (point.y - points[i].y) / (points[j].y - points[i].y) + points[i].x)
      ) {
        result = !result;
      }
    }
    return result;
  }

});



// WEBPACK FOOTER //
// ./src/assets/javascripts/nesting/intersection.js